import { Component, OnInit, PLATFORM_ID, Inject } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { Title, Meta } from '@angular/platform-browser';
import { LinkService } from '../../../_services/langhfre.service';
import { ActivatedRoute } from '@angular/router';
import { WebsiteService } from 'src/app/_services/website.service';
import { LoadScriptService } from 'src/app/_services/load-script.service';

@Component({
  selector: 'app-credits',
  templateUrl: './credits.component.html',
  styleUrls: ['./credits.component.scss']
})
export class CreditsComponent implements OnInit {

  country: string;
  encodedData: any;
  decodedData: any;
  premiumDecodedData: any;
  paymentModeOption: any;
  premiumUserpaymentModeOption: any;
  twentyPackFinalAmount: any;
  constructor(
    private titleService: Title,
    private metaTagService: Meta,
    @Inject(PLATFORM_ID) private platformId: Object,
    private LinkService: LinkService,
    private route: ActivatedRoute,
    public paymentService: WebsiteService,
    public loadScript: LoadScriptService
  ) { }

  ngOnInit() {
    if (isPlatformBrowser(this.platformId)) {
      if (localStorage.getItem("country-trinka") == null || localStorage.getItem("country-trinka") == "") {
        this.loadGeoAPIScript();
      }
    }
    this.titleService.setTitle('使用 Trinka 點數，靈活啟用所需功能');
    this.metaTagService.updateTag({ name: 'description', content: "Trinka 提供多項進階功能，這些功能皆需使用點數。你可以依需求使用點數，也可隨時加購，彈性又方便。" });
    this.metaTagService.updateTag({ property: 'og:title', content: '使用 Trinka 點數，靈活啟用所需功能' });
    this.metaTagService.updateTag({ property: 'og:description', content: "Trinka 提供多項進階功能，這些功能皆需使用點數。你可以依需求使用點數，也可隨時加購，彈性又方便。" });
    this.metaTagService.updateTag({ property: 'og:url', content: 'https://www.trinka.ai/tw/features/credits' });
    this.metaTagService.updateTag({ property: 'og:type', content: 'website' });
    this.metaTagService.updateTag({ name: 'language', content: 'zh-tw' });
    this.LinkService.addTag({ rel: 'canonical', href: 'https://www.trinka.ai/tw/features/credits' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'x-default', href: 'https://www.trinka.ai/features/credits' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'en-us', href: 'https://www.trinka.ai/features/credits' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'ja-jp', href: 'https://www.trinka.ai/jp/features/credits' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'zh-tw', href: 'https://www.trinka.ai/tw/features/credits' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'zh-cn', href: 'https://trinka.enago.cn/features/credits' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'ko-kr', href: 'https://www.trinka.ai/kr/features/credits' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'es-es', href: 'https://www.trinka.ai/es/features/credits' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'pt-pt', href: 'https://www.trinka.ai/pt/features/credits' });

    this.country = localStorage.getItem("country-trinka") ? localStorage.getItem("country-trinka") : "en";
      console.log(this.country);
      this.route.params.subscribe(params => {
        this.encodedData = params['id'];
        this.paymentService.getPlans(this.encodedData,3).subscribe(resp => {
          if (resp['message'] == 'success') {
            this.decodedData = resp['data']
            this.paymentModeOption = this.decodedData;
            // console.log("Country is: ",this.country);
            console.log("Data", this.decodedData);
            // console.log("Final Amount: ",this.decodedData[2].final_amount);
            // var twentyPack = this.decodedData[3].amount;
            // this.twentyPackFinalAmount = twentyPack / this.decodedData[3].discount * 100;
            // console.log(twentyPack);
            // console.log("twentyPack Final Amount", this.twentyPackFinalAmount);
          }
        });
      });

      this.route.params.subscribe(params => {
        this.encodedData = params['id'];
        this.paymentService.premiumGetPlan(this.encodedData,3).subscribe(resp => {
          if (resp['message'] == 'success') {
            this.premiumDecodedData = resp['data']
            this.premiumUserpaymentModeOption = this.premiumDecodedData;
            // console.log("Country is: ",this.country);
            console.log("Premium user Data: ", this.premiumDecodedData);
            // console.log("Final Amount: ",this.decodedData[2].final_amount);
            // var twentyPack = this.decodedData[3].amount;
            // this.twentyPackFinalAmount = twentyPack / this.decodedData[3].discount * 100;
            // console.log("twentyPack Final Amount", this.twentyPackFinalAmount);
          }
        });
      });
  }

  loadGeoAPIScript() {
    if (isPlatformBrowser(this.platformId)) {
      var scriptName = "geoIP"
      this.loadScript.loadScript(scriptName, '//geoip-js.com/js/apis/geoip2/v2.1/geoip2.js')
        .then(() => {
          console.log(`${scriptName} loaded successfully`);
          var onSuccess = function (location) {
            localStorage.setItem("country-trinka", location['country']['iso_code'])
          };

          var onError = function (error) {
            localStorage.setItem("country-trinka", "IN")
          };
          try {
            //@ts-ignore
            geoip2.city(onSuccess, onError);
          } catch (error) {
            console.log(error)
          }
        })
        .catch(() => {
          console.error(`Failed to load ${scriptName}`);
        });
    }
  }

  perMonth: any;
  perMonthAfterDis: any;
  calculatePlan(finalAmt, credits) {    
    this.perMonthAfterDis = finalAmt / credits
    return parseFloat(this.perMonthAfterDis).toFixed(2);
  }
  calculateDiscount(annualAmt, finalAmt, credits) {
    let actualAmt = annualAmt * credits / (2)
    let perMonthAfterDis: any = ((actualAmt - finalAmt) * 100) / (actualAmt);
    return parseFloat(perMonthAfterDis).toFixed(0);
  }
  calculateDiscountFinal(originalAmt, finalAmt, credits) {
    const originalTotal = originalAmt * credits;
    const discount = ((originalTotal - finalAmt) * 100) / originalTotal;
    return Math.round(discount);
  }

  scroll(el: HTMLElement) {
    el.scrollIntoView({ behavior: 'smooth' });
  }

}
